import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';
import { RecaptchaFormsModule, RecaptchaModule } from 'ng-recaptcha';

import { EmptyDataComponent } from '../../../shared/components/empty-data/empty-data.component';
import { FirstOverlaysComponent } from '../../../shared/components/first-overlays/first-overlays.component';
import { FirstTimeComponent } from '../../../shared/components/first-time/first-time.component';
import { PasswordFormatComponent } from '../../../shared/components/password-format/password-format.component';
import { ProfileBannerComponent } from '../../../shared/components/profile-banner/profile-banner.component';
import { SexSelectorComponent } from '../../../shared/components/sex-selector/sex-selector.component';
import { ModuleSharedModule } from '../../../shared/modules/module-shared.module';
import { AssetsUrlPipe } from '../../../shared/pipes/assets-url/assets-url.pipe';
import { CheckIconPipe } from '../../../shared/pipes/check-icon/check-icon.pipe';
import { HtmlSeguroPipe } from '../../../shared/pipes/html-seguro.pipe';
import { IsNullEmptyPipe } from '../../../shared/pipes/is-null-empty/is-null-empty.pipe';
import { VideoPipe } from '../../../shared/pipes/video/video.pipe';
import { CardsConsumidorComponent } from '../components/cards-consumidor/cards-consumidor.component';
import { InputSmsComponent } from '../components/input-sms/input-sms.component';
import { InputTelComponent } from '../components/input-tel/input-tel.component';
import { InputsRegistroComponent } from '../components/inputs-registro/inputs-registro.component';
import { PasswordsComponent } from '../components/passwords/passwords.component';
import {
  PasswordsValidatorComponent,
} from './../../../private/shared/components/passwords-validator/passwords-validator.component';
import { SummaryPricePipe } from './../../../shared/pipes/summary-price/summary-price.pipe';

@NgModule({
  declarations: [
    CardsConsumidorComponent
    , InputsRegistroComponent
    , InputSmsComponent
    , InputTelComponent
    , PasswordsComponent
  ],
  imports: [
    IonicModule
    , CommonModule
    , ModuleSharedModule
    , FormsModule
    , ReactiveFormsModule
    , RecaptchaModule
    , RecaptchaFormsModule
  ],
  exports: [
    CardsConsumidorComponent
    , EmptyDataComponent
    , PasswordFormatComponent
    , InputsRegistroComponent
    , InputSmsComponent
    , InputTelComponent
    , PasswordsComponent
    , PasswordsValidatorComponent
    , SexSelectorComponent
    , FirstTimeComponent
    , FirstOverlaysComponent
    , ProfileBannerComponent
    , HtmlSeguroPipe
    , AssetsUrlPipe
    , CheckIconPipe
    , IsNullEmptyPipe
    , VideoPipe
    , SummaryPricePipe
    , RecaptchaModule
    , RecaptchaFormsModule
    , TranslateModule
  ],
  providers: [
    IsNullEmptyPipe
  ]
})
export class PublicSharedModule { }
